import Alpine from "alpinejs";
import {searchClient} from '@algolia/client-search';

const appId = 'I4QX0HHXO9';
const apiKey = '466b6552a24fe0f6ae3559109048c363';
const indexName = 'dev_wagtail_book_bookcontentpage';
Alpine.data("searchApp", () => ({
    searchInit() {
        this.searchClient = searchClient(appId, apiKey);
        this.searchReady = true
        this.performSearch = debounce(this.performSearchRaw.bind(this), 300)
        this.currentPage = document.querySelector('[data-book-page-id]')
        this.bookId = parseInt(document.querySelector('[data-book-id]').getAttribute('data-book-id'));
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('search_query')) {
            this.searchTerm = urlParams.get('search_query');
            this.performSearch();
        }
    },
    searchClient: null,
    searchResults: [],
    searchTerm: '',
    searchReady: false,
    totalHits: 0,
    bookId: 0,
    currentPage: null,
    currentPageId: 0,
    searchResultsPage: 0,
    hitsPerPage: 5,
    page: 0,
    totalPages: 0,
    range: 3,
    clearSearch() {
        this.searchTerm = '';
        this.searchResults = [];
        this.page = 0;
        this.clearTranscript();
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete('search_query');
        const url = new URL(window.location);
        url.search = urlParams.toString();
        window.history.pushState({}, '', url);
    },
    clearTranscript() {
        const pageId = parseInt(this.currentPage.getAttribute('data-book-page-id'));
        window.dispatchEvent(new CustomEvent('clear-transcript', {
            detail: {pageId},
            bubbles: true,
            composed: true
        }));
    },
    async performSearchRaw() {
        const minChars = 3;
        if (!this.searchTerm || this.searchTerm.length < minChars) {
            this.searchResults = [];
            this.page = 0;
            this.clearTranscript()
            return;
        }

        this.currentPageId = parseInt(this.currentPage.getAttribute('data-book-page-id'));
        const searchResults = await this.searchClient.searchSingleIndex({
            indexName,
            searchParams: {
                query: this.searchTerm,
                page: this.page,
                hitsPerPage: this.hitsPerPage,
                filters: `book_id:${this.bookId}`,
                optionalFilters: [`id:${this.currentPageId}<score=999>`],
                attributesToRetrieve: ['id', 'title', 'transcript', 'raw_transcript', 'page_number', 'go_to_url'],
                attributesToHighlight: ['raw_transcript'],
                attributesToSnippet: ['transcript:20'],
                highlightPreTag: '<span class="search-term-highlight">',
                highlightPostTag: '</span>'
            },
        }, {});
        this.totalHits = searchResults.nbHits;
        this.totalPages = searchResults.nbPages;
        this.searchResults = searchResults.hits.map(hit => ({
            ...hit,
            snippet: hit._snippetResult.transcript.value,
            highlight: hit._highlightResult.raw_transcript.value,
            goToUrl: this.applyAnyExistingUrlParams(hit.go_to_url),
        }))

        const currentPageHighlight = this.searchResults.find(hit => hit.id === this.currentPageId);
        if (currentPageHighlight) {
            window.dispatchEvent(new CustomEvent('show-transcript', {
                detail: {
                    pageId: this.currentPageId,
                    html: currentPageHighlight.highlight
                },
                bubbles: true,
                composed: true
            }));
        }
    },
    visiblePages() {
        if (this.totalPages <= 5) {
            return Array.from({length: this.totalPages}, (_, i) => i);
        }

        // First page
        const list = [0];

        const left = Math.max(1, this.page - 1);
        const right = Math.min(this.totalPages - 2, this.page + 1);


        if (left > 1) {
            list.push('left-ellipsis');
        }

        // Pages in the window
        for (let i = left; i <= right; i++) {
            list.push(i);
        }

        // Right Ellipsis
        if (right < this.totalPages - 2) {
            list.push('right-ellipsis');
        }

        // Last page
        list.push(this.totalPages - 1);
        return list;
    },
    nextPage() {
        if (this.page + 1 < this.totalPages) {
            this.page++;
            this.searchResultsPage = this.page
            this.performSearch();
        }
    },
    prevPage() {
        if (this.page > 0) {
            this.page--;
            this.searchResultsPage = this.page
            this.performSearch();
        }
    },
    goToPage(page) {
        console.log(page)
        if (page === 'left-ellipsis') {
            this.page = this.page - 2;
            this.searchResultsPage = this.page
            this.performSearch();
            return;
        }
        if (page == 'right-ellipsis') {
            this.page = this.page + 2;
            this.searchResultsPage = this.page
            this.performSearch();
            return;
        }
        if (page >= 0 && page <= this.totalPages) {

            this.page = page;
            this.searchResultsPage = this.page
            this.performSearch();
        }
    },
    applyAnyExistingUrlParams(url) {
        try {
            const linkUrl = new URL(url);
            const currentParams = new URLSearchParams(linkUrl.search);
            const params = new URLSearchParams(window.location.search);
            for (const [key, value] of params.entries()) {
                if (!currentParams.has(key)) {
                    currentParams.set(key, value);
                }
            }

            if (this.searchTerm) {
                currentParams.set('search_query', this.searchTerm);
            }

            linkUrl.search = currentParams.toString();
            return linkUrl.href;
        } catch (error) {
            console.error('Invalid URL:', url);
            return url;
        }

    },
}))

function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}